import type { FC } from 'react';
import styles from '../styles/completion.module.scss';
import ActionButton from '../components/action-button';

type InvalidNavigationProps = {
    onClose: () => void;
};

const InvalidNavigation: FC<InvalidNavigationProps> = (props) => {
    return (
        <div className={styles.completion}>
            <div className={styles.completeTitle}>エラー</div>
            <div className={styles.completeText}>エラーが発生しました</div>
            <ActionButton className={styles.closeButton} title="閉じる" onClick={props.onClose} />
        </div>
    );
};

export default InvalidNavigation;
